import * as React from 'react';
import { Flex } from 'reflexbox';
import {StyledClose, Wrap} from "./styled/modal";
import {ButtonPlain} from "../forms/styled/form";
import {Container} from "../layout/container";
import {H1} from "../typography/styled/typography";
import {useEffect} from "react";
import { Image, ImageVariant } from '../featuredInSection/FeaturedInSection';
import {ImageDetailContent} from "./ImageDetailContent";

export interface ModalData {
  dimension: string,
  material: string,
  year: number,
  title: string,
  image: Image,
  variants: ImageVariant[],
  photo?: {
    original: {
      src: string;
      height: string;
      width: string;
    }
    alt: string;
  };
}

interface ModalProps {
  onClose: () => void,
  children?: React.ReactNode,
  data: ModalData | null,
  title: string,
  lang: string,
  isDark?: boolean,
}

const Modal = (props: ModalProps) => {
  const { data } = props;

  useEffect(() => {
    if (data) {
      document.body.classList.add('disable-scroll')
    } else {
      document.body.classList.remove('disable-scroll')
    }
  }, [data]);

  if (data === null) {
    return null;
  }

  return (
    <Wrap>
      <Container>
        <Flex flexWrap={'wrap'} flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'} px={[0, 3, 3, 0, 0]}>
          <H1>
            {props.title}
          </H1>
          <ButtonPlain onClick={props.onClose}>
            <StyledClose color={props.isDark ? 'white' : '#000'} />
          </ButtonPlain>
        </Flex>
        <ImageDetailContent data={data} imgTitle={props.title} />
      </Container>
    </Wrap>
  );
};

export default Modal;
